module.exports = __webpack_public_path__ + "static/media/contacto.580675e1.jpg";